import {
  GET_HOWE_WIDGET_INFO_SUCCESS,
  GET_HOWE_WIDGET_INFO_ERROR,
} from "../../constants/action-types";

export const homeWidgetInitialState = {};

export const reducer = (state, { type, payload }) => {
  switch (type) {
    case GET_HOWE_WIDGET_INFO_SUCCESS: {
      return {
        ...state,
        ...payload,
      };
    }

    case GET_HOWE_WIDGET_INFO_ERROR: {
      return homeWidgetInitialState;
    }

    default:
      return state;
  }
};
